import React, { useState } from "react";
import { Sparkles, Loader2, ChevronDown, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export const DicoAssistenteButton = ({ cid, onCreated, label = "Compila con assistente", testid = "dico-ai-btn" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/clienti/${cid}/dico/auto`);
      for (let i = 0; i < 60; i++) {
        await wait(3000);
        const { data: j } = await api.get(`/dico/auto-jobs/${data.job_id}`);
        if (j.status === "done") {
          toast.success(`${j.numero} ${j.mode === "updated" ? "aggiornata" : "creata"} dall'assistente: ${j.n_componenti} componenti da ${j.n_foto} foto${j.n_pdf ? ` e ${j.n_pdf} PDF` : ""}`);
          if (j.attached) toast.success("PDF della DiCo inserito in Installazione › Dichiarazione di conformità");
          if (j.archived) toast.success(`${j.numero} archiviata su Aruba Drive (cartella DiCo)`);
          else toast.warning(`Non archiviata su Aruba: ${j.archive_error || "errore"}. Riprova con "Archivia su Aruba".`, { duration: 8000 });
          onCreated(); return;
        }
        if (j.status === "error") { toast.error(j.error || "Assistente non riuscito"); return; }
      }
      toast.error("L'assistente sta impiegando troppo: riprova tra poco");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <button onClick={run} disabled={busy} className="btn-secondary" style={{ color: "#6A1B9A", borderColor: "#CE93D8" }} data-testid={testid}
      title="Aggiorna l'ultima DiCo del cliente (o ne crea una) leggendo note, foto e PDF dell'installazione, materiali e chat">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} {busy ? "L'assistente sta leggendo…" : label}
    </button>
  );
};

export const DicoAiNote = ({ d }) => {
  const [open, setOpen] = useState(false);
  if (!d.created_by_ai) return null;
  return (
    <div className="text-[11px] mt-1" data-testid={`dico-ai-note-${d.id}`}>
      <button onClick={() => setOpen(!open)} className="inline-flex items-center gap-1 font-semibold" style={{ color: "#6A1B9A" }} data-testid={`dico-ai-note-toggle-${d.id}`}>
        {open ? <ChevronDown className="w-3 h-3" /> : <ChevronRight className="w-3 h-3" />}<Sparkles className="w-3 h-3" /> {d.ai_updated_at ? `Aggiornata dall'assistente il ${new Date(d.ai_updated_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}` : "Creata dall'assistente"} · cosa ha letto
      </button>
      {open && <div className="mt-1 p-2 rounded whitespace-pre-wrap" style={{ background: "#F3E5F5", color: "#4A148C" }}>{d.ai_note || "—"}</div>}
    </div>
  );
};
